(function ($) {

let scrollingup = false;
let menushowing = true;
let lastScrollTop = 0;
let fixmenu = 160;
let menuFloating = false;
let menuLanding = false;

let headlineSection = null;
let headlineWrapper = null;
let headlineLines = null;

menuAppearLoad();

// ---------------- INIT ----------------

$(function () {

    headlineSection = document.querySelector('.headline-section');
    headlineWrapper = document.querySelector('.headline-wrapper');
    headlineLines = document.querySelectorAll('.headline-wrapper .line');

    hasScrolled();
});

// ---------------- MENU (unchanged) ----------------

function menuFloat() {

    var $el = $('body').find('.wp-block-group.menu');

    if (!$el.length) return;

    console.log("🔵 menuFloat EXECUTED");

    $el.removeClass('menu-land');
    $el.addClass('menu-float fadein');

    menuFloating = true;
    menuLanding = false;
}

function menuLand() {

    var $el = $('body').find('.wp-block-group.menu');

    if (!$el.length) return;

    console.log("🟢 menuLand EXECUTED");

    // ALWAYS RESET FIRST (critical)
    $el.removeClass('menu-float fadein');
    $el.addClass('menu-land fadein');

    menuLanding = true;
    menuFloating = false;

    // optional cleanup after animation
    setTimeout(() => {
        $el.removeClass('fadein');
    }, 300);
}

function menuAppear() {
    menushowing = true;
    var $menu = $('body').find('.wp-block-group.menu');
    var $logo = $('body').find('.wp-block-group.logo');

    if ($menu.length) $menu.addClass('fadein').removeClass('fadeout');
    if ($logo.length) $logo.addClass('fadein').removeClass('fadeout');
}

function menuAppearLoad() {
    menushowing = true;
    var $menu = $('body').find('.wp-block-group.menu');
    $menu.addClass('fadein').removeClass('fadeout');
}

function menuDisappear() {
    menushowing = false;
    var $menu = $('body').find('.wp-block-group.menu');

    if ($menu.length) {
        $menu.removeClass('fadein').addClass('fadeout');
    }
}

// ---------------- HEADLINE ----------------

function animateHeadline() {

    if (!headlineSection || !headlineWrapper || !headlineLines || !headlineLines.length) return;

    const rect = headlineSection.getBoundingClientRect();

    // ---------------- BASE SCROLL DISTANCE ----------------
    const rawScrollDistance =
        headlineSection.offsetHeight - window.innerHeight;

    // fallback baseline so negative/small sections don't break animation
    const fallbackDistance = window.innerHeight * 1.2;

    const scrollDistance =
        rawScrollDistance > 0 ? rawScrollDistance : fallbackDistance;

    // ---------------- PROGRESS ----------------

    let progress =
        (-rect.top + window.innerHeight * 0.85) / scrollDistance;

    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

    // ---------------- LINES ----------------

    let p1 = clamp(progress / 0.2, 0, 1);

    headlineLines[0].style.opacity = p1;
    headlineLines[0].style.transform =
        `translateY(${(1 - p1) * 20}px)`;

    if (headlineLines[1]) {
        let p2 = clamp((progress - 0.1) / 0.2, 0, 1);

        headlineLines[1].style.opacity = p2;
        headlineLines[1].style.transform =
            `translateY(${(1 - p2) * 20}px)`;
    }

    // ---------------- TIMELINE ----------------

    const entryEnd = 0.8;
    const exitStart = 0.8;
    const exitEnd = 1.6;

    let scale = 0.25;
    let translateY = 80;

    if (progress < entryEnd) {

        let t = clamp(progress / entryEnd, 0, 1);
        t = t * t;

        scale = 0.25 + t * 0.75;
        translateY = 80 - t * 80;

    } else {

        let exitT = clamp(
            (progress - exitStart) / (exitEnd - exitStart),
            0,
            1
        );

        exitT = exitT * exitT;

        scale = 1 - exitT * 0.4;
        translateY = -200 * exitT;
    }

    headlineWrapper.style.transform =
        `translate3d(0, ${translateY}px, 0) scale(${scale})`;
}

// ---------------- SCROLL ----------------

function hasScrolled() {

    const st = $(this).scrollTop();
    const windowsize = $(window).width();
    const hideNum = 456;

    console.log("scroll:", st, "last:", lastScrollTop);

    // ---------------- MENU STATE (FIXED LOGIC) ----------------

    // mobile / small screens → always float
    if (windowsize < 979) {

        if (!menuFloating) {
            console.log("🔵 mobile float");
            menuFloat();
        }

    } else {

        // desktop logic based purely on position
        if (st <= fixmenu) {

            // TOP AREA → LAND
            if (menuFloating || !menuLanding) {
                console.log("🟢 FORCE LAND (top)");
                menuLand();
            }

        } else {

            // SCROLLED DOWN → FLOAT
            if (!menuFloating) {
                console.log("🔵 FORCE FLOAT (scroll > fixmenu)");
                menuFloat();
            }
        }
    }

    // ---------------- MENU HIDE ON SCROLL DOWN ----------------

    if (st > lastScrollTop) {

        if (st > hideNum) {
            menuDisappear();
        }

    } else {

        // scrolling up → ensure menu visible
        if (!menushowing) {
            menuAppear();
        }
    }

    // ---------------- HEADLINE ----------------

    if (headlineSection && headlineWrapper && headlineLines && headlineLines.length) {
        animateHeadline();
    }

    lastScrollTop = st;
}

////////////////////////////////////////
$(window).on('scroll', function () {
    hasScrolled();
});

})(jQuery);


// ---------------- INTERSECTION ----------------

document.addEventListener('DOMContentLoaded', () => {

    const animatedElements = document.querySelectorAll('.animated-element');

    const observer = new IntersectionObserver((entries, observer) => {

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in-viewport');
                observer.unobserve(entry.target);
            }
        });

    }, {
        root: null,
        threshold: 0.3
    });

    animatedElements.forEach(el => observer.observe(el));
});


// ---------------- TAB MODIFICATION FOR EACH PAGE ----------------

document.addEventListener("DOMContentLoaded", function () {
  let tabIndex = null;

  if (document.body.classList.contains("page-corporate-concierge")) {
    tabIndex = 2; // 3rd tab (0-based index)
  } else if (document.body.classList.contains("page-lifestyle-management")) {
    tabIndex = 1; // 2nd tab (0-based index)
  } else {
    return;
  }

  const tabs = document.querySelectorAll(".stk-block-tabs__tab");

  if (tabs.length > tabIndex) {
    // Small delay ensures Stackable has initialized first
    setTimeout(() => {
      tabs[tabIndex].click();
    }, 50);
  }
});

// ---------------- CUSTOM ACCORDFIAN  ----------------
document.addEventListener('toggle', function (e) {

    const accordion = e.target;

    if (accordion.tagName !== 'DETAILS') return;
    if (!accordion.open) return;

    // Only process accordions inside a .minimal-accordian group
    if (!accordion.closest('.minimal-accordian')) return;

    // Close every other open accordion in a .minimal-accordian group
    document.querySelectorAll('.minimal-accordian details[open]').forEach(function(item) {
        if (item !== accordion) {
            item.removeAttribute('open');
        }
    });

}, true);


///////////////////ACCORDIAN IMAGE CHANGE


document.addEventListener("DOMContentLoaded", function () {

  const imageTarget = document.querySelector(".dynamic-right-image-tag img");

  const summaries = document.querySelectorAll(".dynamic-accordian .wp-block-stackable-accordion > summary");

  function updateImage(summary) {
  const details = summary.parentElement;
  const img = details.getAttribute("data-image");

  if (!img || !imageTarget) return;

  console.log("Changing image to:", img);

  const fileName = img.split("/").pop();
  console.log("Image file:", fileName);

  // 🔥 IMPORTANT FIX
  imageTarget.src = img;
  imageTarget.srcset = "";
  imageTarget.sizes = "";
  }

  summaries.forEach(summary => {
    summary.addEventListener("click", function () {
      setTimeout(() => updateImage(this), 50);
    });
  });

});
///scrolling text on homepage

document.addEventListener("DOMContentLoaded", function () {

  const imageTarget = document.querySelector(".dynamic-image-tag img");
  const summaries = document.querySelectorAll(".dynamic-accordian-2col .wp-block-stackable-accordion > summary");

  function updateImage(summary) {
  const details = summary.parentElement;
  const img = details.getAttribute("data-image");

  if (!img || !imageTarget) return;

  console.log("Changing image to:", img);

  const fileName = img.split("/").pop();
  console.log("Image file:", fileName);

  // 🔥 IMPORTANT FIX
  imageTarget.src = img;
  imageTarget.srcset = "";
  imageTarget.sizes = "";
  }

  summaries.forEach(summary => {
    summary.addEventListener("click", function () {
      setTimeout(() => updateImage(this), 50);
    });
  });

});


document.addEventListener('DOMContentLoaded', function () {
    const scrollAreas = document.querySelectorAll('.infinite-text-scroll');

    scrollAreas.forEach(function (scrollArea) {
        if (scrollArea.dataset.scrollInitialized === 'true') {
            return;
        }

        const originalTrack = scrollArea.querySelector(
            ':scope > .infinite-text-scroll__track'
        );

        if (!originalTrack) {
            return;
        }

        const belt = document.createElement('div');
        belt.className = 'infinite-text-scroll__belt';

        scrollArea.insertBefore(belt, originalTrack);
        belt.appendChild(originalTrack);

        function createClone() {
            const clone = originalTrack.cloneNode(true);

            clone.classList.add('infinite-text-scroll__clone');
            clone.setAttribute('aria-hidden', 'true');

            clone
                .querySelectorAll('a, button, input, select, textarea')
                .forEach(function (element) {
                    element.setAttribute('tabindex', '-1');
                });

            belt.appendChild(clone);
        }

        function buildScrollLoop() {
            belt
                .querySelectorAll('.infinite-text-scroll__clone')
                .forEach(function (clone) {
                    clone.remove();
                });

            const trackHeight = originalTrack.offsetHeight;

            if (!trackHeight) {
                return;
            }

            /*
             * The belt must contain enough copies to cover the visible
             * area, plus one additional track for the transition.
             */
            const requiredHeight = scrollArea.clientHeight + trackHeight;

            while (belt.scrollHeight < requiredHeight) {
                createClone();
            }

            const pixelsPerSecond = 30;
            const duration = Math.max(trackHeight / pixelsPerSecond, 15);

            scrollArea.style.setProperty(
                '--scroll-distance',
                trackHeight + 'px'
            );

            scrollArea.style.setProperty(
                '--scroll-duration',
                duration + 's'
            );
        }

        scrollArea.dataset.scrollInitialized = 'true';

        buildScrollLoop();

        if ('ResizeObserver' in window) {
            const resizeObserver = new ResizeObserver(function () {
                buildScrollLoop();
            });

            resizeObserver.observe(originalTrack);
            resizeObserver.observe(scrollArea);
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll(
        '.cp-stable-carousel.stk-block-carousel.stk--infinite-scroll'
    );

    carousels.forEach(function (carousel) {
        let repairTimer;
        let attempts = 0;

        function repairCarousel() {
            const instance = carousel.carousel;

            if (
                !instance ||
                !instance.sliderEl ||
                !instance.slideEls ||
                !instance.clones ||
                !instance.clones.length
            ) {
                return;
            }

            const slider = instance.sliderEl;
            const firstSlide = instance.slideEls[0];
            const firstClone = instance.clones[0];

            /*
             * Recalculate the distance Stackable uses when it moves
             * original slides into the cloned infinite-loop area.
             */
            const loopDistance = Math.abs(
                firstSlide.offsetLeft - firstClone.offsetLeft
            );

            if (!loopDistance) {
                return;
            }

            instance.slideTranslateX =
                (instance.isRTL ? -loopDistance : loopDistance) + 'px';

            instance.cloneTranslateX =
                (instance.isRTL ? loopDistance : -loopDistance) + 'px';

            /*
             * Repair slides that Stackable has already moved using
             * the previous measurement.
             */
            const swappedSlides = Number(instance.swappedSlides) || 0;

            instance.slideEls.forEach(function (slide, index) {
                if (index < swappedSlides) {
                    slide.style.transform =
                        'translateX(' + instance.slideTranslateX + ')';
                }
            });

            instance.clones.forEach(function (clone, index) {
                if (index < swappedSlides) {
                    clone.style.transform =
                        'translateX(' + instance.cloneTranslateX + ')';
                }
            });

            /*
             * Make sure the active slide is precisely aligned with
             * the left edge of the carousel viewport.
             */
            const activeSlide =
                instance.slideEls[instance.currentSlide - 1];

            if (!activeSlide) {
                return;
            }

            const sliderLeft = slider.getBoundingClientRect().left;
            const slideLeft = activeSlide.getBoundingClientRect().left;
            const difference = slideLeft - sliderLeft;

            if (Math.abs(difference) > 2) {
                const previousScrollBehavior =
                    slider.style.scrollBehavior;

                slider.style.scrollBehavior = 'auto';
                slider.scrollLeft += difference;

                requestAnimationFrame(function () {
                    slider.style.scrollBehavior =
                        previousScrollBehavior;
                });
            }
        }

        function scheduleRepair(delay) {
            window.clearTimeout(repairTimer);

            repairTimer = window.setTimeout(
                repairCarousel,
                delay || 50
            );
        }

        function initializeRepair() {
            if (
                carousel.carousel &&
                carousel.carousel.clones &&
                carousel.carousel.clones.length
            ) {
                const slider = carousel.carousel.sliderEl;

                carousel.addEventListener(
                    'stackable-carousel-slide-change',
                    function () {
                        /*
                         * Stackable's normal slide transition is
                         * approximately 300ms.
                         */
                        scheduleRepair(450);
                    }
                );

                if ('onscrollend' in window) {
                    slider.addEventListener(
                        'scrollend',
                        function () {
                            scheduleRepair(30);
                        },
                        { passive: true }
                    );
                }

                if ('ResizeObserver' in window) {
                    const observer = new ResizeObserver(function () {
                        scheduleRepair(100);
                    });

                    observer.observe(carousel);
                }

                carousel.querySelectorAll('img').forEach(function (image) {
                    if (!image.complete) {
                        image.addEventListener(
                            'load',
                            function () {
                                scheduleRepair(50);
                            },
                            { once: true }
                        );
                    }
                });

                scheduleRepair(50);
                return;
            }

            attempts++;

            if (attempts < 120) {
                requestAnimationFrame(initializeRepair);
            }
        }

        initializeRepair();
    });
});

////activate sub-nav for solutions
(function () {
    const navItemSelector = '.mid-nav .wp-block-navigation-item';

    function setActiveItem(hash) {
        const navItems = document.querySelectorAll(navItemSelector);

        navItems.forEach(function (item) {
            const link = item.querySelector('a[href^="#"]');

            item.classList.toggle(
                'sub-active',
                link && link.getAttribute('href') === hash
            );
        });
    }

    // Respond when a navigation link is clicked.
    document.addEventListener('click', function (event) {
        const link = event.target.closest('.mid-nav a[href^="#"]');

        if (!link) {
            return;
        }

        setActiveItem(link.getAttribute('href'));
    });

    // Respond to browser back/forward navigation.
    window.addEventListener('hashchange', function () {
        setActiveItem(window.location.hash);
    });

    // Apply the correct active state when the page loads.
    function initializeSubNavigation() {
        if (window.location.hash) {
            setActiveItem(window.location.hash);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            initializeSubNavigation
        );
    } else {
        initializeSubNavigation();
    }
})();